import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../../services/api';
import { errorMessage } from '../../hooks/useAsync';
import { Alert, Button, Card, Field, Input, PageTitle, Textarea } from '../../components/ui';

export function OrgNew() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [billingEmail, setBillingEmail] = useState('');
  const [notes, setNotes] = useState('');
  const [firstAdmin, setFirstAdmin] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const org = await api.createOrganization({
        name: name.trim(),
        billing_email: billingEmail.trim() || null,
        notes,
        first_admin_email: firstAdmin.trim() || null,
      });
      navigate(`/organizations/${org.id}?tab=subscription`, { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-xl">
      <PageTitle title={t('orgs.new')} subtitle={t('orgs.newSubtitle')} />
      <form onSubmit={submit}>
        <Card>
          <div className="flex flex-col gap-3">
            <Field label={t('orgs.name')}>
              <Input required value={name} onChange={(e) => setName(e.target.value)} />
            </Field>
            <Field label={t('orgs.billingEmail')}>
              <Input type="email" value={billingEmail} onChange={(e) => setBillingEmail(e.target.value)} />
            </Field>
            <Field label={t('orgs.firstAdmin')} hint={t('orgs.firstAdminHint')}>
              <Input type="email" value={firstAdmin} onChange={(e) => setFirstAdmin(e.target.value)} />
            </Field>
            <Field label={t('orgs.notes')} hint={t('orgs.notesHint')}>
              <Textarea value={notes} onChange={(e) => setNotes(e.target.value)} />
            </Field>
            {error && <Alert>{error}</Alert>}
            <div className="flex justify-end gap-2">
              <Button onClick={() => navigate(-1)}>{t('common.cancel')}</Button>
              <Button type="submit" variant="primary" busy={busy}>
                {t('common.create')}
              </Button>
            </div>
          </div>
        </Card>
      </form>
    </div>
  );
}
